/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'google+': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 12',
    data: '<path pid="0" d="M6.348 4.814v2.377h3.434a3.119 3.119 0 0 1-3.434 2.377A3.614 3.614 0 0 1 2.639 6a3.617 3.617 0 0 1 3.709-3.563 3.72 3.72 0 0 1 2.468.876c.525-.5.481-.565 1.81-1.751A6.55 6.55 0 0 0 6.353 0 6.185 6.185 0 0 0 0 6a6.185 6.185 0 0 0 6.353 6c5.244 0 6.524-4.314 6.1-7.186zm11.462.376V3h-1.561v2.19H14v1.561h2.249V9h1.561V6.751H20V5.19z" fill-rule="evenodd" data-name="ic_google+"/>'
  }
})
